export default {
  methods: {
    // 纠正number
    correctStrNum (str) {
      if (str === '') {
        return ''
      }
      const reg = /^[0]+/
      const fSymo = str.indexOf('-')
      let _v = str.replace(/\-/g,'')
       _v = _v.replace(reg, "")
      const digitSymolIdx = _v.indexOf('.')
      if (fSymo > -1) {
        if (digitSymolIdx === 0) {
          return '-0' + _v
        }
       return '-' + _v
      }
      if (digitSymolIdx === 0) {
        return '0' + _v
      }
      if (_v === '') {
        return '0'
      }
      return _v
    },
    // 插入
    insertStr (source, start, strSym) {
      return source.slice(0, start) + strSym + source.slice(start)
    },
    // 删除
    deleteStr (source, start) {
      return source.slice(0, start) + source.slice(start + 1)
    },
    // 转化百分位
    transform (str, type) {
      if (str === '' || str === undefined || str === null) {
        return ''
      }
      let strNum = typeof str === 'string' ? str : JSON.stringify(str) // 转str
      const isF = strNum.indexOf('-')
      str = strNum = isF > -1 ? strNum.replace(/\-/g, ''): strNum
      const strNumLength = strNum.length // 整个str的length
      const digitSymolIdx = strNum.indexOf('.')
      const digitLength = digitSymolIdx > -1 ? strNum.slice(0, digitSymolIdx).length : strNumLength
      const digitNum = digitSymolIdx > -1 ? strNum.slice(0, digitLength) : strNum
      const DecimalNum = digitSymolIdx > -1 && strNum.slice(digitSymolIdx + 1)
      const DecimalNumLength = DecimalNum && DecimalNum.length
      // 除100
      if (type === 'divide') {
        if (digitSymolIdx === strNumLength-1 ) {
          return isF > -1 ? '-' + str : str
        }
        if (strNum === '') {
          return isF > -1 ? '-' + str : str
        }
        if (digitSymolIdx > -1) {
          if (digitLength <= 2) {
            const digit_v = digitNum.padStart(3, '0')
            const v = digit_v + DecimalNum
            return isF > -1? '-' + this.insertStr(v, 1, '.') : this.insertStr(v, 1, '.')
          }
          const v = this.deleteStr(strNum, digitSymolIdx)
          return isF > -1 ? '-' + this.insertStr(v, digitSymolIdx - 2, '.') : this.insertStr(v, digitSymolIdx - 2, '.')
        } else {

          if (strNumLength <= 2) {
            const v = strNum.padStart(3, '0')
            return isF > -1 ? '-' + this.insertStr(v, 1, '.') : this.insertStr(v, 1, '.')
          }
          return isF > -1 ? '-' + this.insertStr(strNum, strNumLength - 2, '.') : this.insertStr(strNum, strNumLength - 2, '.')
        }
      }
      // 乘100
      if (digitSymolIdx > -1) {
        // const _digitNum =  JSON.stringify(Number(digitNum)) === '0' ? '' : JSON.stringify(Number(digitNum))
        const _digitNum = digitNum

        if (DecimalNumLength === 1) {
          const v = _digitNum + DecimalNum
          const newStrlength = v.length
          return isF > -1 ? '-' + v.padEnd(newStrlength + 1, '0') : v.padEnd(newStrlength + 1, '0')
        }
        if (DecimalNumLength === 2) {
          const v = _digitNum + DecimalNum
          return isF > -1 ? '-' + v : v
        }
        const newStrNum = _digitNum + DecimalNum
        // let v =  this.deleteStr(strNum, digitSymolIdx)
        const v = this.insertStr(newStrNum, digitSymolIdx + 2, '.')

        return isF > -1 ? '-' + v : v
      } else {

        return isF > -1 ? '-' + strNum.padEnd(strNumLength + 2, '0') : strNum.padEnd(strNumLength + 2, '0')
      }
    }
  }
}
